import type { NavigationEntry } from "@positive/ui";
import "@ui5/webcomponents-icons/dist/list.js";
import "@ui5/webcomponents-icons/dist/product.js";
import "@ui5/webcomponents-icons/dist/measure.js";
import "@ui5/webcomponents-icons/dist/money-bills.js";
import "@ui5/webcomponents-icons/dist/shipping-status.js";
import "@ui5/webcomponents-icons/dist/table-view.js";
import "@ui5/webcomponents-icons/dist/accounting-document-verification.js";
import "@ui5/webcomponents-icons/dist/edit.js";
import "@ui5/webcomponents-icons/dist/bar-code.js";
import "@ui5/webcomponents-icons/dist/palette.js";
import "@ui5/webcomponents-icons/dist/add-product.js";

import "@ui5/webcomponents-icons/dist/settings.js";

import { platformPermissions } from "../platform/permissions";
import { catalogPermissions } from "./permissions";

/** Master Data B entries of the navigation registry (group `masterData`, plan module `md`). */
export const masterDataCatalogNavigation: readonly NavigationEntry[] = [
  {
    key: "md.items",
    labelKey: "nav.items",
    icon: "product",
    path: "/md/items",
    permission: catalogPermissions.itemView,
  },
  {
    key: "md.itemQuickUpdate",
    subGroup: "setupTools",
    labelKey: "nav.itemQuickUpdate",
    icon: "edit",
    path: "/md/item-quick-update",
    permission: catalogPermissions.quickUpdateView,
  },
  {
    key: "md.barcodeLabels",
    subGroup: "setupTools",
    labelKey: "nav.barcodeLabels",
    icon: "bar-code",
    path: "/md/barcode-labels",
    permission: catalogPermissions.barcodePrint,
  },
  {
    key: "md.lookups",
    subGroup: "setupTools",
    labelKey: "nav.inventoryLookups",
    icon: "list",
    path: "/md/lookups",
    permission: catalogPermissions.lookupView,
  },
  {
    key: "md.itemCategories",
    subGroup: "setupTools",
    labelKey: "nav.itemCategories",
    icon: "palette",
    path: "/md/item-categories",
    permission: catalogPermissions.lookupView,
  },
  {
    key: "md.unitGroups",
    subGroup: "setupTools",
    labelKey: "nav.unitGroups",
    icon: "measure",
    path: "/md/unit-groups",
    permission: catalogPermissions.unitGroupView,
  },
  {
    key: "md.warehouses",
    labelKey: "nav.warehouses",
    icon: "shipping-status",
    path: "/md/warehouses",
    permission: catalogPermissions.warehouseView,
  },
  {
    key: "md.accountFamilies",
    subGroup: "setupTools",
    labelKey: "nav.accountFamilies",
    icon: "accounting-document-verification",
    path: "/md/account-families",
    permission: catalogPermissions.accountFamilyView,
  },
  {
    key: "md.modifierSets",
    subGroup: "setupTools",
    labelKey: "nav.modifierSets",
    icon: "add-product",
    path: "/md/modifier-sets",
    permission: catalogPermissions.itemView,
  },
  {
    key: "md.priceLists",
    labelKey: "nav.priceLists",
    icon: "money-bills",
    path: "/md/price-lists",
    permission: catalogPermissions.priceListView,
  },
  {
    key: "md.serviceTariffs",
    subGroup: "setupTools",
    labelKey: "nav.serviceTariffs",
    icon: "table-view",
    path: "/md/service-tariffs",
    permission: catalogPermissions.serviceTariffView,
  },
  {
    key: "md.settings",
    subGroup: "setupTools",
    labelKey: "nav.mdSettings",
    icon: "settings",
    path: "/platform/settings/md",
    permission: platformPermissions.settingsView,
  },
];
